import Get from 'lodash/get';

export const isLoading = state => Get(state, 'reports.loading', false);
export const getReports = state => Get(state, 'reports.reports', []);
export const isLoadingReport = (state, reportId) => Get(state, 'reports.loadingReports', []).includes(reportId);
export const getPasswordProtectedReport = state => Get(state, 'reports.passwordProtectedReport', undefined);
export const showPasswordDialog = state => getPasswordProtectedReport(state) !== undefined;
